import type { Testimonial } from '../types'

export const testimonials: Testimonial[] = [
  {
    id: 'miguel',
    initials: 'MR',
    name: 'Miguel Ramírez',
    role: 'Techador · Indiana',
    quote:
      'La primera semana me llegaron 4 cotizaciones nuevas de Google. Un solo contrato pagó la web 10 veces. Mejor inversión que he hecho.',
    metric: '4 cotizaciones la 1ª semana',
    packageLabel: 'Paquete $600',
  },
  {
    id: 'maria',
    initials: 'DM',
    name: 'Dra. María González',
    role: 'Dentista · Chicago',
    quote:
      'En 3 semanas me llegaron 9 pacientes nuevos. Todos dijeron que me encontraron en Google y que mi clínica se veía muy profesional.',
    metric: '9 pacientes en 3 semanas',
    packageLabel: 'Paquete $1,200',
  },
  {
    id: 'juan',
    initials: 'JV',
    name: 'Juan Verde',
    role: 'Landscaping · Texas',
    quote:
      'Antes dependía 100% del boca a boca. Ahora tengo mi agenda llena con clientes que me encuentran solos. No puedo creer que tardé tanto en hacerlo.',
    metric: 'Agenda llena todo el mes',
    packageLabel: 'Paquete $600',
  },
  {
    id: 'carlos',
    initials: 'CM',
    name: 'Carlos Medina',
    role: 'Plomero · Houston',
    quote:
      'Antes daba mi número por Facebook y se perdían los mensajes. Ahora la gente me llama directo desde la web. 12 trabajos el primer mes.',
    metric: '12 trabajos el primer mes',
    packageLabel: 'Paquete $600',
  },
  {
    id: 'ana',
    initials: 'AT',
    name: 'Ana Torres',
    role: 'Salón de belleza · Phoenix',
    quote:
      'Mis clientas agendan solas desde el celular a cualquier hora. Dejé de perder una hora diaria contestando mensajes.',
    metric: '+40% de citas agendadas',
    packageLabel: 'Paquete $1,200',
  },
  {
    id: 'roberto',
    initials: 'RD',
    name: 'Roberto Díaz',
    role: 'Taller mecánico · Los Ángeles',
    quote:
      'Aparezco arriba de talleres que llevan 20 años en la zona. La web se ve seria y eso hace que la gente confíe antes de llamar.',
    metric: 'Top 3 en Google local',
    packageLabel: 'Paquete $1,800',
  },
  {
    id: 'lucia',
    initials: 'LH',
    name: 'Lucía Herrera',
    role: 'Repostería · Miami',
    quote:
      'Los pedidos entran por el formulario mientras duermo. La web se pagó sola en dos semanas de temporada.',
    metric: 'Se pagó en 2 semanas',
    packageLabel: 'Paquete $600',
  },
  {
    id: 'pedro',
    initials: 'PS',
    name: 'Pedro Salazar',
    role: 'Contratista · Chicago',
    quote:
      'Mando el link de mi web antes de cada estimado y cierro trabajos más grandes. Los clientes ya llegan convencidos.',
    metric: 'Presupuestos 30% más altos',
    packageLabel: 'Paquete $1,800',
  },
  {
    id: 'jose',
    initials: 'JN',
    name: 'José Nieves',
    role: 'HVAC · Dallas',
    quote:
      'Antes gastaba en volantes cada mes. Ahora el trabajo llega de Google sin pagar un dólar en anuncios.',
    metric: '$0 en publicidad pagada',
    packageLabel: 'Paquete $1,200',
  },
]
